import React from 'react';
import { Link } from 'react-router-dom';
import { Shield, Lock, Eye, Database, UserCheck, AlertCircle, ArrowLeft, Home, FileText, MessageCircle } from 'lucide-react';

const PrivacyPolicy = () => {
  const sections = [
    {
      title: 'مقدمة',
      icon: Shield,
      content: [
        'نحن في منصة "منصتي" التعليمية نلتزم بحماية خصوصية وبيانات طلابنا الثانوية العامة. هذه السياسة توضح كيفية جمع واستخدام وحماية بياناتك الشخصية.',
        'باستخدامك لمنصتنا، فإنك توافق على الممارسات الموضحة في هذه السياسة.'
      ]
    },
    {
      title: 'البيانات التي نجمعها',
      icon: Database,
      content: [
        'البيانات الشخصية الأساسية: الاسم الكامل، البريد الإلكتروني، رقم الهاتف، العنوان.',
        'البيانات التعليمية: الصف الدراسي، المدرسة، المواد الدراسية، المستوى الأكاديمي.',
        'بيانات الدفع: معلومات البطاقات البنكية (مشفرة ومحمية)، سجلات الاشتراكات.',
        'بيانات النشاط: سجل الدروس المشاهدة، التقدم في الكورسات، نتائج الاختبارات.',
        'البيانات التقنية: عنوان IP، نوع المتصفح، نظام التشغيل، بيانات الاستخدام.'
      ]
    },
    {
      title: 'كيف نستخدم بياناتك',
      icon: UserCheck,
      content: [
        'توفير الخدمات التعليمية: الوصول للكورسات، متابعة التقدم، تقديم الدعم.',
        'تحسين التجربة التعليمية: تخصيص المحتوى، اقتراح كورسات مناسبة.',
        'التواصل معك: إشعارات مهمة، تحديثات تعليمية، دعم فني.',
        'الأغراض الإدارية: إدارة الاشتراكات، معالجة الدفعات، إعداد التقارير.',
        'الأمان والحماية: منع الاحتيال، حماية الحسابات، ضمان أمان المنصة.'
      ]
    },
    {
      title: 'حماية البيانات',
      icon: Lock,
      content: [
        'نستخدم أحدث تقنيات التشفير لحماية بياناتك أثناء النقل والتخزين.',
        'الوصول للبيانات محدود للموظفين المعتمدين فقط.',
        'نقوم بتحديثات أمنية دورية لحماية النظام من التهديدات.',
        'نحتفظ بنسخ احتياطية مشفرة للبيانات في مواقع آمنة.',
        'نلتزم بالمعايير الدولية لحماية بيانات الطلاب القصر.'
      ]
    },
    {
      title: 'مشاركة البيانات مع الأطراف الثالثة',
      icon: Eye,
      content: [
        'لا نبيع بياناتك لأي طرف ثالث.',
        'نشارك البيانات فقط مع:',
        'مزودي الدفع المعتمدين (لإتمام عمليات الدفع).',
        'الجهات الحكومية عند الطلب القانوني.',
        'شركاء التقنية المعتمدين (لتقديم الخدمات).',
        'جميع الأطراف الثالثة ملزمة بحماية بياناتك.'
      ]
    },
    {
      title: 'حقوقك كطالب',
      icon: UserCheck,
      content: [
        'الوصول لبياناتك: يمكنك طلب نسخة من بياناتك الشخصية.',
        'تصحيح البيانات: يمكنك تحديث معلوماتك الشخصية في أي وقت.',
        'حذف الحساب: يمكنك طلب حذف حسابك وبياناتك.',
        'إلغاء الاشتراك: يمكنك إلغاء اشتراكك في أي وقت.',
        'الشكاوى: يمكنك تقديم شكاوى حول كيفية معاملة بياناتك.'
      ]
    },
    {
      title: 'ملفات تعريف الارتباط (Cookies)',
      icon: Database,
      content: [
        'نستخدم ملفات تعريف الارتباط لتحسين تجربتك:',
        'ملفات أساسية: لتشغيل الموقع وتسجيل الدخول.',
        'ملفات الأداء: لتحسين سرعة وأداء الموقع.',
        'ملفات التحليل: لفهم كيفية استخدامك للموقع.',
        'ملفات التسويق: لعرض محتوى مناسب ومفيد.',
        'يمكنك التحكم في ملفات تعريف الارتباط من إعدادات المتصفح.'
      ]
    },
    {
      title: 'احتفاظ البيانات',
      icon: Lock,
      content: [
        'نحتفظ ببياناتك طوال فترة استخدامك للمنصة.',
        'بعد حذف الحساب: نحذف البيانات الشخصية خلال 30 يوماً.',
        'نحتفظ بالبيانات المطلوبة قانونياً للمدة المحددة بالقانون.',
        'البيانات التعليمية: نحتفظ بها لدعم العملية التعليمية.',
        'البيانات المالية: نحتفظ بها للمدة المطلوبة لل auditing.'
      ]
    },
    {
      title: 'التحديثات والتغييرات',
      icon: AlertCircle,
      content: [
        'قد نقوم بتحديث هذه السياسة بشكل دوري.',
        'سيتم إشعارك بأي تغييرات مهمة عبر البريد الإلكتروني.',
        'آخر تحديث لهذه السياسة: 27 يناير 2026.',
        'استمرار استخدامك للمنصة يعني قبولك للتغييرات.',
        'نوصي بمراجعة هذه السياسة بشكل دوري.'
      ]
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50/50">
      {/* Header */}
      <div className="bg-gradient-to-br from-green-600 to-green-800 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <div className="text-center">
            <div className="w-20 h-20 bg-white/20 rounded-3xl flex items-center justify-center mx-auto mb-6 backdrop-blur-sm">
              <Shield size={40} />
            </div>
            <h1 className="text-4xl font-black mb-4">سياسة الخصوصية</h1>
            <p className="text-xl text-green-100 mb-8 max-w-2xl mx-auto">
              نلتزم بحماية خصوصيتك وبياناتك التعليمية بأعلى معايير الأمان
            </p>
            <Link
              to="/help"
              className="inline-flex items-center gap-2 bg-white/20 backdrop-blur-sm px-6 py-3 rounded-2xl hover:bg-white/30 transition-all"
            >
              <ArrowLeft size={20} />
              العودة لمركز المساعدة
            </Link>
          </div>
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        
        {/* Last Updated */}
        <div className="bg-blue-50 border border-blue-200 rounded-2xl p-6 mb-8">
          <div className="flex items-center gap-3">
            <AlertCircle className="text-blue-600" size={24} />
            <div>
              <h3 className="font-black text-blue-900">آخر تحديث</h3>
              <p className="text-blue-700">27 يناير 2026</p>
            </div>
          </div>
        </div>

        {/* Sections */}
        <div className="space-y-8">
          {sections.map((section, index) => (
            <div key={index} className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden">
              <div className="p-6 border-b border-gray-100">
                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 bg-green-50 text-green-600 rounded-xl flex items-center justify-center">
                    <section.icon size={24} />
                  </div>
                  <h2 className="text-2xl font-black text-gray-900">{section.title}</h2>
                </div>
              </div>
              <div className="p-6">
                <ul className="space-y-3">
                  {section.content.map((item, itemIndex) => (
                    <li key={itemIndex} className="flex items-start gap-3">
                      <div className="w-2 h-2 bg-green-500 rounded-full mt-2 flex-shrink-0"></div>
                      <p className="text-gray-700 leading-relaxed">{item}</p>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>

        {/* Contact Information */}
        <div className="mt-12 bg-gradient-to-br from-gray-50 to-gray-100 rounded-3xl p-8">
          <h2 className="text-2xl font-black text-gray-900 mb-6 text-center">لديك أسئلة حول الخصوصية؟</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="bg-white rounded-2xl p-6">
              <h3 className="font-black text-gray-900 mb-3">تواصل معنا</h3>
              <p className="text-gray-600 mb-4">فريق حماية البيانات متاح للإجابة على استفساراتك</p>
              <Link
                to="/contact"
                className="inline-flex items-center gap-2 text-green-600 hover:text-green-700 font-black"
              >
                تواصل معنا
                <ArrowLeft size={16} className="rotate-180" />
              </Link>
            </div>
            <div className="bg-white rounded-2xl p-6">
              <h3 className="font-black text-gray-900 mb-3">البريد الإلكتروني</h3>
              <p className="text-gray-600 mb-4">يمكنك مراسلتنا مباشرة على:</p>
              <a 
                href="mailto:privacy@manasti.com"
                className="text-green-600 hover:text-green-700 font-black"
              >
                privacy@manasti.com
              </a>
            </div>
          </div>
        </div>

        {/* Quick Links */}
        <div className="mt-8 flex flex-wrap gap-4 justify-center">
          <Link
            to="/terms"
            className="inline-flex items-center gap-2 bg-white border border-gray-200 px-6 py-3 rounded-2xl hover:bg-gray-50 transition-all"
          >
            <FileText size={20} />
            الشروط والأحكام
          </Link>
          <Link
            to="/contact"
            className="inline-flex items-center gap-2 bg-white border border-gray-200 px-6 py-3 rounded-2xl hover:bg-gray-50 transition-all"
          >
            <MessageCircle size={20} />
            تواصل معنا
          </Link>
          <Link
            to="/"
            className="inline-flex items-center gap-2 bg-white border border-gray-200 px-6 py-3 rounded-2xl hover:bg-gray-50 transition-all"
          >
            <Home size={20} />
            الصفحة الرئيسية
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
